import React, { Component } from 'react';

import './index.scss';
import { AppStateContext } from 'src/contexts/app-state-provider.context';
import Layout from 'src/components/layout';
import Disclaimer from '../../components/disclaimer';
import ConsumerPanel from '../../components/consumer-panel';
import ThreeColumnCards from '../../components/three-column-cards';
import { Link } from 'gatsby';
import { TranslatedBlock } from 'src/components/language';
import TwoWorlds from '../../images/desktop-banner-homepage-new-24Nov.jpg';
import ResultOfTrial from '../../images/result-of-trial.png';
import Durability from '../../images/durability.png';
import ImproveVision from '../../images/improve-vision.png';
import FourMonths from '../../images/4-months.png';
import TwoWays from '../../images/2ways.png';
import MobileHeroBanner from '../../images/mobile-banner-homepgage-new-24Nov.jpg';

import ConsultDoctor from '../../components/consult-doctor';
const symbol = '<';

class PatientPage extends Component {
  static contextType = AppStateContext;
  componentDidMount() {
    this.context.setSection('patient');
    this.context.setPage('home');
  }

  handleClickScroll() {
    const element = document.getElementById('vabysmo-main');
    if (element) {
      const yOffset = -130;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      // 👇 Will scroll smoothly to the top of the next section
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  render() {
    const title = {
      english: 'What is VABYSMO?'
    };
    return (
      <Layout title={title} showNavbar={true} className="patient">
        <section>
          
          <div className="two-worlds ">
            <picture>
              <source
                   media="(max-width: 767px)"
                  srcSet={MobileHeroBanner} 
                 />
              <img onClick={this.handleClickScroll} onKeyDown={this.handleClickScroll} loading="lazy" src={TwoWorlds} alt="Scroll Down" />
            </picture>

          </div>
        </section>
        <section className="homepage-header container-fluid" id="vabysmo-main">
          <div className="row top-container" >
            <div className="col-12 col-lg-12 col-xl-12 d-flex flex-column">
              <div className="" >
                <div className="container d-flex flex-column align-items-center top">
                  <div className="px-2 py-4">
                    <TranslatedBlock language="english">
                      <ul >
                        <b>VABYSMO<sup>®</sup> is a registered medicine given by injection into the eye to treat adults with </b>
                        <li>neovascular (wet) age-related macular degeneration (wet AMD)</li>
                        <li>diabetic macular oedema (DMO)</li>
                        <li>macular oedema secondary to retinal vein occlusion (RVO)</li>
                      </ul>

                      <p className='about-vabysmo'>
                         VABYSMO targets the two pathways that cause eye disease. These pathways are called VEGF-A and Ang-2<sup>*</sup>
                      </p>
                      <p className='references'><sup>*</sup>VEGF-A, vascular endothelial growth factor A; Ang-2, Angiopoietin 2.</p>
                    </TranslatedBlock>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ConsultDoctor bgColor="blue" />
        <section className='why-vabysmo-right'>
          <div className="container">
            <div className="row">
              <div className="col-md-6 offset-md-3 col-xs-12 py-1 pt-4 ">

                <h2 className="mb-4 mt-3 text-center">Why VABYSMO?</h2>
                <div className="row">
                  <div className="col-3"><img loading="lazy" src={ImproveVision} alt="Improves vision quickly" className='vabysmo-right' /></div>
                  <div className="col-9"><p><span className='highlight-text'>Improves vision quickly</span> with results maintained after 2 years of treatment</p></div>
                </div>
                <div className="row">
                  <div className="col-3"><img loading="lazy" src={Durability} alt="dual-pathway inhibition provides" className='vabysmo-right' /></div>
                  <div className="col-9"><p><span className='highlight-text'>Can help quickly dry excessive fluid</span> that causes swelling in the back of the eye</p></div>

                </div>

                <div className="row">
                  <div className="col-3"><img loading="lazy" src={FourMonths} alt="months between treatments" className='vabysmo-right' /></div>
                  <div className="col-9"><p>Delivers a chance for up to <span className='highlight-text'>4 months between treatments</span></p></div>
                </div>

                <div className="row">
                  <div className="col-3"><img loading="lazy" src={TwoWays} alt="registered treatment designed to block 2 pathways" className='vabysmo-right py-4' /></div>
                  <div className="col-9"><p>VABYSMO is the only NZ registered treatment designed to <span className='highlight-text'>block 2 pathways of wet AMD, DMO and RVO </span> (VEGF-A and Ang-2).</p>
                    <p className='references'>
                      VEGF-A, vascular endothelial growth factor A; Ang-2, Angiopoietin 2.</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
        
        <div className="container three-section-heading">
          <div className="row">
            <h2 className='text-color-purple'>Downloadable Resources</h2>
            <p>Take advantage of these downloadable resources to learn more about your condition and VABYSMO</p>
          </div>
        </div>
        <ThreeColumnCards />

        <ConsultDoctor bgColor="blue" />
        <Disclaimer />
        <ConsumerPanel />
      </Layout>
    );
  }
}

export default PatientPage;
